export const TAGANDTRACK = {
    title: 'TAGANDTRACK',
    brandName: 'Tag and Track',
    primaryColor: '#007c92',
    androidAppLink: 'https://play.google.com/store/apps/details?id=com.trackimo.tagandtrack',
    iosAppLink: 'https://apps.apple.com/app/vodafone-business-tag-track/id1477489342',
    localizeLink: 'https://web-tnt-plus.s3-eu-west-1.amazonaws.com/locale/',
};
